'use strict';

var EditPortForwarding = require('actionGroups/portForwarding/PortForwarding');

module.exports = {
  Model: EditPortForwarding,
};
